module.exports = __webpack_public_path__ + "static/media/Bread.9fd11c6e.jpg";